import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const ConsentWrapper = styled.div`
    display: grid;
    gap: ${getPurpurSpacing('300')};
    margin-top: ${getPurpurSpacing('300')};

    ${purpurMedia('lg')`    
        margin-top: ${getPurpurSpacing('400')};
    `}
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('200')};

    button {
        width: 100%;
    }

    ${purpurMedia('lg')`
        flex-direction: row;
        button {
            width: auto;
        }
    `}
`;
